import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
@Injectable()
export class ClientOrderService {
  api_url: string = environment.apiEndPoint;

  constructor(private http: HttpClient) { }

  getToken() {
    return localStorage.getItem(environment.TOKEN_SECRET);
  }
  getOrdersWithFilter(filter: any) {
    const configs = {
      withCredentials: true,
      headers: { Authorization: `Bearer ${this.getToken()}` },
    };
    return this.http.post<any>(`${this.api_url}client_orders`, filter, configs)
  }
  getAdminOrdersWithFilter(filter : any) {
    const configs = {
      withCredentials: true,
      headers: { Authorization: `Bearer ${this.getToken()}` },
    };
    return this.http.post<any>(this.api_url + 'admin_trade_master',filter, configs)
  }
  getTradeReportsWithFilter(filter : any) {
    const configs = {
      withCredentials: true,
      headers: { Authorization: `Bearer ${this.getToken()}` },
    };
    return this.http.post<any>(this.api_url + 'trade_master',filter, configs)
  }
  deleteClientTrade(tradeId : any, WalletType : string) {
    const configs = {
      withCredentials: true,
      headers: { Authorization: `Bearer ${this.getToken()}` },
    };
    return this.http.get<any>(this.api_url + `delete-client-trade/${tradeId}/${WalletType}` , configs)
  }
  deleteExchangeTrade(id : any) {
    const configs = {
      withCredentials: true,
      headers: { Authorization: `Bearer ${this.getToken()}` },
    };
    return this.http.get<any>(this.api_url + `delete-exchange-trade/${id}` , configs)
  }
  getExchangeReportsWithFilter(filter : any) {
    const configs = {
      withCredentials: true,
      headers: { Authorization: `Bearer ${this.getToken()}` },
    };
    return this.http.post<any>(this.api_url + 'exchange_trade_master',filter, configs)
  }
  saveManualExchangeTrade(filter : any) {
    const configs = {
      withCredentials: true,
      headers: { Authorization: `Bearer ${this.getToken()}` },
    };
    return this.http.post<any>(this.api_url + 'save_manual_exchange_trade',filter, configs)
  }
  getSettlementReport(filter : any) {
    const configs = {
      withCredentials: true,
      headers: { Authorization: `Bearer ${this.getToken()}` },
    };
    return this.http.post<any>(this.api_url + 'settlement_report',filter, configs)
  }
}



// WEBPACK FOOTER //
// ./src/app/clientorderreport/clientorderreport.service.ts